import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect } from "react";
import { $api, type components } from "../../helper";
import { Table, type TableProps } from "antd";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import { useParams } from "react-router";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function ManagementPageDetail() {
  const { setDashboardName } = useStore(useDashboardName);
  const params = useParams();
  const { data, isLoading } = $api.useQuery("get", "/site-api/v1/section/", {
    params: {
      query: {
        page_u_id: params.id ?? "",
      },
    },
  });
  const detail = $api.useQuery("get", "/site-api/v1/page/");
  useEffect(() => {
    setDashboardName("جزئیات صفحه");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteSectionItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "نام صفحه",
      dataIndex: "section_title",
      key: "section_title",
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={`/management-page/${params.id}/${record.u_id}`}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={`/management-page/${params.id}/${record.u_id}`}
            className="text-primary-500!"
          />
        </div>
      ),
    },
  ];
  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <div className="w-full flex justify-between items-center">
        <CustomBreadcrumb
          items={[
            {
              title: "مدیریت صفحات",
              href: "/management-page",
            },
            {
              title: detail?.data?.data?.find((e) => e.u_id === params.id)
                ?.title,
            },
          ]}
        />
      </div>

      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteSectionItem"]>
            loading={isLoading}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data?.data}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
